import { LOGIN_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import loginWith from 'root/src/client/logic/auth/thunks/loginWith'
import providers from 'root/src/shared/constants/providers'

export default {
	[LOGIN_FORM_MODULE_ID]: [
		{
			action: (_, { previousRoute }) => loginWith(providers.twitch)({ ...previousRoute }),
		},
		{
			action: (_, { previousRoute }) => loginWith(providers.google)({ ...previousRoute }),
		},
		{
			action: (_, { previousRoute }) => loginWith(providers.tiktok)({ ...previousRoute }),
		},
		{
			action: (_, { previousRoute }) => loginWith(providers.facebook)({ ...previousRoute }),
		},
	],
}
